module.exports = __webpack_public_path__ + "static/images/styles/images/challenges-bg.1a221af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./styles/images/challenges-bg.jpg
// module id = 3611
// module chunks = 11